<template>
    <div class="slide_header">
        <div class="grid grid-cols-3 gap-4 title_slide">
            <div class="col-span-2 ...">Nổi bật nhất</div>
            <div class="...">
                <div style="text-align: right;">
                    <span v-for="item in 4" :key="item" >
                        <b-icon v-if="item == (active + 1)" style="color: black;" scale="2" icon="dot" aria-hidden="true"></b-icon>
                        <b-icon v-else style="color: grey;" scale="2" icon="dot" aria-hidden="true"></b-icon>
                    </span>
                </div>
            </div>
        </div>
        <vue-glide v-if="data.length > 0" class="mgt-10" :perView="1" type="carousel" :peek="{ before: 0, after: 30 }" v-model="active">
            <vue-glide-slide
            v-for="i in data"
            :key="i.id">
                <div>
                    <div @click="viewDetail(i.id,i.slug)" class="image_slide cursor-pointer">
                        <img  height="176" width="100%" style="border-radius: 10px;" :src="i.image" fluid alt="vclick hot blog image">
                    </div>
                    <div @click="viewDetail(i.id,i.slug)" class="slide_title fw-700 mgt-10 ft-16 cursor-pointer">
                        {{ i.name }}
                    </div>
                    <div style="color: grey;" class="mgt-10">
                        
                        <div class="grid grid-cols-3 gap-4 slide_content">
                            <div class="col-span-2 ... slider_category">{{ i.category_name }}</div>
                            <div class="... time_format">
                                {{ i.updated_time | toDMY }}
                            </div>
                        </div>
                    </div>
                    <!-- <span class="fw-700 mgt-20">
                        
                    </span> -->
                </div>
            </vue-glide-slide>
        </vue-glide>
    </div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'
import { getHotBlog } from '@/api/otp'

export default {
    // props: ['data'],
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },
    data(){
        return{
            active: 0,
            data: [
            ]
        }
    },
    methods: {
        viewDetail(id,slug){
            this.$router.push('/blog/chi-tiet/' +id +'/'+slug)
        },
        fetchHotBlog(){
            getHotBlog({}).then(res => {
                this.data = res.data
            })
        },

    },
    created(){
        this.fetchHotBlog()
    }
}
</script>

<style>
.title_slide {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 133%;
    margin-bottom: 15px;
}
.image_slide img {
    width: 96%;
    max-height: 200px;
}
.slide_title {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: -0.03em;
    color: #34404B;
    margin-top: 15px;
}
.slide_content {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 142%;
    letter-spacing: -0.03em;
    color: #9AA0A5;
    margin-top: 15px;
    width: 96%;
}
.slide_content .time_format {
    text-align: right;
}
</style>